import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var ExperienceIcon = function(props) {
    return /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "18",
                r: "16.5",
                fill: "white",
                stroke: "#FFDF00",
                "stroke-width": "3"
            }),
            /*#__PURE__*/ _jsx("mask", {
                id: "mask0_66_88",
                maskUnits: "userSpaceOnUse",
                x: "7",
                y: "8",
                width: "20",
                height: "20",
                children: /*#__PURE__*/ _jsx("rect", {
                    x: "7",
                    y: "8",
                    width: "20",
                    height: "20",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ _jsx("g", {
                mask: "url(#mask0_66_88)",
                children: /*#__PURE__*/ _jsx("path", {
                    d: "M13.6667 24.6668C13.2083 24.6668 12.816 24.5036 12.4896 24.1772C12.1632 23.8509 12 23.4585 12 23.0002V20.5002H14.5V18.6252C14.0139 18.5974 13.5521 18.4897 13.1146 18.3022C12.6771 18.1147 12.2778 17.8335 11.9167 17.4585V16.5418H10.9583L8.25 13.8335C8.75 13.1946 9.36806 12.7432 10.1042 12.4793C10.8403 12.2154 11.5833 12.0835 12.3333 12.0835C12.7083 12.0835 13.0729 12.1113 13.4271 12.1668C13.7812 12.2224 14.1389 12.3266 14.5 12.4793V11.3335H24.5V22.1668C24.5 22.8613 24.2569 23.4516 23.7708 23.9377C23.2847 24.4238 22.6944 24.6668 22 24.6668H13.6667ZM16.1667 20.5002H21.1667V22.1668C21.1667 22.4029 21.2465 22.6009 21.4062 22.7606C21.566 22.9203 21.7639 23.0002 22 23.0002C22.2361 23.0002 22.434 22.9203 22.5937 22.7606C22.7535 22.6009 22.8333 22.4029 22.8333 22.1668V13.0002H16.1667V13.5002L21.1667 18.5002V19.6668H20L17.625 17.2918L17.4583 17.4585C17.2639 17.6529 17.059 17.8266 16.8438 17.9793C16.6285 18.1321 16.4028 18.2502 16.1667 18.3335V20.5002ZM11.6667 14.8752H13.5833V16.6668C13.75 16.7779 13.9236 16.8543 14.1042 16.896C14.2847 16.9377 14.4722 16.9585 14.6667 16.9585C14.9861 16.9585 15.2743 16.9099 15.5312 16.8127C15.7882 16.7154 16.0417 16.5418 16.2917 16.2918L16.4583 16.1252L15.2917 14.9585C14.8889 14.5557 14.4375 14.2536 13.9375 14.0522C13.4375 13.8509 12.9028 13.7502 12.3333 13.7502C12.0556 13.7502 11.7917 13.771 11.5417 13.8127C11.2917 13.8543 11.0417 13.9168 10.7917 14.0002L11.6667 14.8752ZM19.5 22.1668H13.6667V23.0002H19.625C19.5833 22.8752 19.5521 22.7432 19.5312 22.6043C19.5104 22.4654 19.5 22.3196 19.5 22.1668Z",
                    fill: "#FFDF00"
                })
            })
        ]
    }));
};
